import lang from "../helper/langHelper";

export const STAFF_ROLE = [
  { label: "Sales", value: "Sales" },
  { label: "Operations", value: "Operations" },
  { label: "Support", value: "Support" },
  { label: "Marketing", value: "Marketing" },
];

export const permissionKeys = {
  Dashboard: "Dashboard",
  Students: "Students",
  Tutor: "Tutor",
  Employees: "Employees",
  Class: "Class",
  Branch: "Branch",
  Role: "Role",
  Booking: "Booking",
  Transaction: "Transaction",
  Promotion: "Promotion",
  Content: "Content",
  EmailTemplate: "Email",
  Notification: "Notification",
  chats: "Chats",
  faq: "FAQ",
  Support: "Support",
  Course: "Course",
  Subscription: "Subscription",
  SupportChat: "SupportChat",
  Accountant: "Accountant",
  SubscriptionQuery: "SubscriptionQuery",
  withdrawRequest: "WithdrawRequest",
  Testimonial: "Testimonial",
};

export const permissionFormData = [
  {
    label: lang("Dashboard"),
    key: "dashboard-management",
    permissionKey: permissionKeys.Dashboard,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Students"),
    key: "student-management",
    permissionKey: permissionKeys.Students,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Class"),
    key: "class-management",
    permissionKey: permissionKeys.Tutor,
    isLog: false,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Branch"),
    key: "branch-management",
    permissionKey: permissionKeys.Course,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Employees"),
    key: "employee-management",
    permissionKey: permissionKeys.Category,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Course Sub Category"),
    key: "sub-category-management",
    permissionKey: permissionKeys.SubCategory,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Staff Management"),
    key: "staff-management",
    permissionKey: permissionKeys.Staff,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Rights Management"),
    key: "role-management",
    permissionKey: permissionKeys.Role,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Booking Management"),
    key: "booking-management",
    permissionKey: permissionKeys.Booking,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Transaction Management"),
    key: "transaction-management",
    permissionKey: permissionKeys.Transaction,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Promotion/Discount Management"),
    key: "promotion-discount",
    permissionKey: permissionKeys.Promotion,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Content Management"),
    key: "content-management",
    permissionKey: permissionKeys.Content,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Email Template Management"),
    key: "email-template-management",
    permissionKey: permissionKeys.EmailTemplate,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Notification Management"),
    key: "notification-management",
    permissionKey: permissionKeys.Notification,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Chats"),
    key: "chats-management",
    permissionKey: permissionKeys.chats,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("FAQ"),
    key: "faq-management",
    permissionKey: permissionKeys.faq,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Subscription Management"),
    key: "subscription-management",
    permissionKey: permissionKeys.Subscription,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Subscription Query Management"),
    key: "subscription-query-management",
    permissionKey: permissionKeys.SubscriptionQuery,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Withdraw Request Management"),
    key: "withdraw-request-management",
    permissionKey: permissionKeys.withdrawRequest,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Support Management"),
    key: "support-management",
    permissionKey: permissionKeys.Support,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  // {
  //   label: lang("Support Chats"),
  //   key: "support-chats",
  //   permissionKey: permissionKeys.SupportChat,
  //   isView: false,
  //   isAdd: false,
  //   isEdit: false,
  //   isDelete: false,
  // },
  {
    label: lang("Accountant Transaction Management"),
    key: "accountant-transaction-management",
    permissionKey: permissionKeys.Accountant,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    label: lang("Testimonial Management"),
    key: "testimonial-management",
    permissionKey: permissionKeys.Testimonial,
    isView: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
];

export const cities = [
  "Toronto",
  "Montreal",
  "Vancouver",
  "Calgary",
  "Edmonton",
  "Ottawa",
  "Winnipeg",
  "Quebec City",
  "Hamilton",
  "Kitchener",
  "London",
  "Victoria",
  "Halifax",
  "Oshawa",
  "Windsor",
  "Saskatoon",
  "Regina",
  "St. John's",
  "Kelowna",
  "Barrie",
  "Sherbrooke",
  "Guelph",
  "Kingston",
  "St. Catharines",
  "Sudbury",
];
